<template>
  <!-- Google Tag Manager (noscript) -->
  <noscript
    ><iframe
      src="https://www.googletagmanager.com/ns.html?id=GTM-PW5PKB8 "
      height="0"
      width="0"
      style="display: none; visibility: hidden"
    ></iframe
  ></noscript>
  <!-- End Google Tag Manager (noscript) -->
  <navigation
    v-if="navigationProps"
    :global-nav-links="navigationProps.globalNavLinks"
    :global-service-nav-links="navigationProps.globalServiceNavLinks"
    :searchFieldLabel="navigationProps.searchFieldLabel"
    :search-page-url="navigationProps.searchPageUrl"
    :subsite="subsiteProp"
  />
  <slot></slot>
  <footer-component
    v-if="footerData"
    :phone="footerProps?.phone"
    :email="footerProps?.email"
    :address="footerProps?.address"
    :footerLinkColumns="footerProps?.footerLinkColumns"
    :socialMediaLinks="footerProps?.socialMediaLinks"
    :subsite="subsiteProp"
    v-bind="{ ...footerProps }"
  />
</template>

<script setup lang="ts">
import { ref, onBeforeMount, computed, toRefs } from "vue";
import { getNavigationAndFooter } from "@/util/api";
import { INavigationProps } from "@/types/components/INavigationProps";
import { IFooterProps } from "@/types/components/IFooterProps";

import Navigation from "@organisms/Navigation/Navigation.ce.vue";
import FooterComponent from "@organisms/Footer/Footer.ce.vue";

interface IWrapperProps {
  pageGui?: string;
}

const navigationData = ref<INavigationProps | null>(null);
const footerData = ref<IFooterProps | null>(null);
const isLoading = ref(true);

const props = defineProps<IWrapperProps>();
const { pageGui } = toRefs(props);

onBeforeMount(async () => {
  if (pageGui?.value) {
    const navAndFooter = await getNavigationAndFooter(pageGui.value);
    navigationData.value = navAndFooter.navigation;
    footerData.value = navAndFooter.footer;
    isLoading.value = false;
  }
});

const footerProps = computed(() => {
  if (!footerData.value) return;
  return {
    phone: footerData.value.phone,
    email: footerData.value.email,
    addressHeader: footerData.value.addressHeader,
    address: footerData.value.address,
    footerLinkColumns: footerData.value.footerLinkColumns,
    socialMediaLinks: footerData.value.socialMediaLinks,
    subsite: footerData.value.subsite,
  };
});

const navigationProps = computed(() => {
  if (!navigationData.value) return;

  return {
    globalNavLinks: navigationData.value.globalNavLinks
      ? navigationData.value.globalNavLinks
      : [],
    globalServiceNavLinks: navigationData.value.globalServiceNavLinks
      ? navigationData.value.globalServiceNavLinks
      : [],
    searchFieldLabel: navigationData.value.searchFieldLabel,
    searchPageUrl: navigationData.value.searchPageUrl,
    subsite: navigationData.value.subsite,
  };
});

const subsiteProp = computed(() => {
  //console.log("subsite value: ", navigationProps.value?.subsite);
  return navigationProps.value?.subsite ? navigationProps.value?.subsite : "cowi";
});
</script>
